import { api } from './client'
import type { CoachingEstimate, CoachingRequest, CoachingResponse } from '@/types/coaching'

export interface ProviderPing {
  ok: boolean
  provider?: string
  model?: string
  ready?: boolean
  thinks?: boolean
  /** Models a letter can be written with (empty on Ollama). */
  models?: { id: string; blurb: string; thinks: boolean }[]
  /** Prepaid Anthropic credit (USD) to count letters against; null when not set. */
  creditUsd?: number | null
}

export function generateCoaching(req: CoachingRequest): Promise<CoachingResponse> {
  return api.post('/api/generate-coaching', req)
}

/** Starts a streamed letter: server-sent events, or JSON when the distress floor answers instead. */
export function streamCoaching(req: CoachingRequest): Promise<Response> {
  return api.stream('/api/generate-coaching/stream', req)
}

export function estimateCoaching(req: CoachingRequest): Promise<CoachingEstimate> {
  return api.post('/api/estimate-coaching', req)
}

export function fetchProviderPing(): Promise<ProviderPing> {
  return api.get('/api/ping')
}
